"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsMappers = void 0;
var SpotifyPlayer = __importStar(require("./components/SpotifyPlayer/SpotifyPlayer"));
var Video = __importStar(require("./components/VideoLegacy/VideoLegacy"));
var MusicPlayer = __importStar(require("./components/MusicPlayer/MusicPlayer"));
var DisqusComments = __importStar(require("./components/DisqusComments/DisqusComments"));
var SpotifyFollow = __importStar(require("./components/SpotifyFollow/SpotifyFollow"));
var PinItPinWidget = __importStar(require("./components/PinItPinWidget/PinItPinWidget"));
var FlickrBadgeWidget = __importStar(require("./components/FlickrBadgeWidget/FlickrBadgeWidget"));
var FlashComponent = __importStar(require("./components/FlashComponent/FlashComponent"));
var LoginButton = __importStar(require("./components/LoginButton/LoginButton"));
var Breadcrumbs = __importStar(require("./components/Breadcrumbs/Breadcrumbs"));
exports.componentsMappers = {
    Video: Video,
    SpotifyPlayer: SpotifyPlayer,
    MusicPlayer: MusicPlayer,
    DisqusComments: DisqusComments,
    SpotifyFollow: SpotifyFollow,
    PinItPinWidget: PinItPinWidget,
    FlickrBadgeWidget: FlickrBadgeWidget,
    FlashComponent: FlashComponent,
    LoginButton: LoginButton,
    Breadcrumbs: Breadcrumbs,
};
//# sourceMappingURL=componentExtensions.js.map